import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { nl2br } from 'react-js-nl2br';

import parse from 'html-react-parser';

import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import { reqGET, translate } from '../../../Utils';

import Loader from '../../Loader/Loader';

import { language } from './Language';

import { api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const dados = useRef(null);

    const { pathname } = useLocation();

    const [data, set_data] = useState(data_interface);

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        // await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
        let res = await reqGET(`${api_crud_route}/type/${getTokenInfo().companycode}/corporate`)
        if (Array.isArray(res.data) && res.data.length > 0) {
            set_data(res.data[0])
            set_dados(dados.current = res.data[0])
            console.log('res.data', res.data)
            console.log('dados.current', dados.current)
        }
        else {
            set_dados(dados.current = data_interface)
        }
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await fetchInfo('')

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    return isloading ?
        <Loader />
        :
        <main>
            <div className={`dash-cards header d-none`}>
                <div className="container">
                    <h2 className="dash-title">{translate(dados.current.content[0].title, lang)}</h2>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 mb-5 mb-xl-10">
                            <div className="card-body border-top p-4">
                                <div className="row mb-4">

                                    {/* IMAGEM E TÍTULO */}
                                    <div className="col-12 col-md-3 p-4 bg-white shadow-sm">
                                        <div className="d-flex flex-column align-items-center mt-3">
                                            {dados.current.content[0]?.media?.image?.[0]?.link ? (
                                                <img
                                                    className="img-fluid p-3 mb-3"
                                                    src={dados.current.content[0]?.media?.image?.[0]?.link}
                                                    alt=""
                                                />
                                            ) : null}

                                            <h5 className="fw-bold my-3 text-center">
                                                {translate(dados.current.content[0]?.title, lang)}
                                                {permissions.current.edit === true ? (
                                                    <Link
                                                        className="button button-update ms-2 text-dark"
                                                        to={{
                                                            pathname: endpoints.regist,
                                                            state: { item: data, operation: "edit" },
                                                        }}
                                                        replace
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </Link>
                                                ) : null}
                                            </h5>
                                        </div>
                                    </div>

                                    {/* TEXTO, CONTACTOS, MORADA E MAPA */}
                                    <div className="col-12 col-md-9 p-4 bg-white shadow-sm">
                                        <div className="mt-3">
                                            {parse(translate(dados.current.content[0]?.text, lang))}
                                        </div>

                                        {/* BLOCOS DE CONTACTOS + MAPA */}
                                        <div className="mt-5">
                                            <div className="row mb-4">
                                                {/* CONTACTOS E MORADA */}
                                                <div className="col-12 col-lg-6">
                                                    {dados.current.content[0].contacts["morada"] && (
                                                        <div>
                                                            <strong>{language[lang].morada}</strong>
                                                            <p>{nl2br(dados.current.content[0].contacts["morada"])}</p>
                                                        </div>
                                                    )}
                                                    
                                                    {dados.current.content[0].contacts["website"] && (
                                                        <div>
                                                            <strong>{language[lang].website}</strong>
                                                            <p>{dados.current.content[0].contacts["website"]}</p>
                                                        </div>
                                                    )}

                                                    {dados.current.content[0].contacts["email"] && (
                                                        <div>
                                                            <strong>{language[lang].email}</strong>
                                                            <p>{dados.current.content[0].contacts["email"]}</p>
                                                        </div>
                                                    )}

                                                    {dados.current.content[0].contacts["tlf"] && (
                                                        <div>
                                                            <strong>{language[lang].tlf}</strong>
                                                            <p>{dados.current.content[0].contacts["tlf"]}</p>
                                                        </div>
                                                    )}

                                                    {dados.current.content[0].contacts["tlm"] && (
                                                        <div>
                                                            <strong>{language[lang].tlm}</strong>
                                                            <p>{dados.current.content[0].contacts["tlm"]}</p>
                                                        </div>
                                                    )}                                                    
                                                </div>

                                                {/* MAPA */}
                                                <div className="col-12 col-lg-6">
                                                    <div style={{ width: "100%", height: "250px" }}>
                                                        <iframe
                                                            title="Localização"
                                                            width="100%"
                                                            height="100%"
                                                            style={{ border: 0, borderRadius: "8px" }}
                                                            loading="lazy"
                                                            allowFullScreen
                                                            referrerPolicy="no-referrer-when-downgrade"
                                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3043.667219750731!2d-7.508199223476173!3d40.28314197146134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd3d23965f1c0bf9%3A0x7a343bec8335c738!2sR.%20Dr.%20Ant%C3%B3nio%20Pl%C3%A1cido%20da%20Costa%2016%20v%2C%206200-176%20Covilh%C3%A3!5e0!3m2!1spt-PT!2spt!4v1761817146114!5m2!1spt-PT!2spt"
                                                        ></iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* CONTEÚDO ADICIONAL */}
                                        {Array.isArray(dados.current.content) &&
                                            dados.current.content.length > 1
                                            ? dados.current.content.map((el_content, k_content) => {
                                                if (k_content > 0) {
                                                    return (
                                                        <div key={k_content} className="mt-5 pt-3 border-top">
                                                            <h5 className="mb-4">
                                                                <strong>{translate(el_content.title, lang)}</strong>
                                                            </h5>
                                                            <p>{parse(translate(el_content.text, lang))}</p>
                                                        </div>
                                                    );
                                                } else return null;
                                            })
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

}